import { global } from '@loaders.gl/loader-utils';
var version = typeof "2.3.13" !== 'undefined' ? "2.3.13" : '';
global.loaders = Object.assign(global.loaders || {}, {
  VERSION: version
});
export default global.loaders;
//# sourceMappingURL=init.js.map


// WEBPACK FOOTER //
// ./~/@loaders.gl/core/dist/esm/lib/init.js